import http from '../http-common';

class QuestionsDataService {
  getAll() {
    return http.get("/survey-questions");
  }

  get(id) {
    return http.get(`/survey-questions/${id}`);
  }

  create(data) {
    return http.post("/survey-questions/add", data);
  }

  update(data) {
    return http.put(`/survey-questions/update`, data);
  }

  delete(id) {
    return http.put(`/survey-questions/delete/${id}`);
  }

  getAllQuestionCategoryWise(id) {
    return http.get(`/surveys/category-questions/${id}`);
  }
}

export default new QuestionsDataService();
